import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

export default function TableItem({
  instagram,
  handleEdit,
  handleSold,
  handleDelete,
  handleCheckboxChange,
  checkedItems,
}) {
  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  const copied = () => {
    toast.success("Text Copied", {
      position: "bottom-center",
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <tr key={instagram.id}>
      {/* <th scope="row">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            // name="chk_child"
            defaultValue={instagram.id}
            onChange={handleCheckboxChange}
            // checked={checkedItems.includes(instagram.id)}
          />
        </div>
      </th> */}
      <td className="id" style={{ display: "none" }}>
        {/* <Link to="#" className="fw-medium link-primary"> */}
        {instagram.id}
        {/* </Link> */}
      </td>
      <td className="customer_name">{instagram.id}</td>
      <td className="email">{instagram.email}</td>

      <td className="date">{timeSince(new Date(instagram.created_at))}</td>
      <td className="status">
        <span
          className={`badge  text-uppercase ${
            instagram.state == true
              ? "badge-soft-warning"
              : "badge-soft-success"
          }`}
          style={{ fontSize: 14 }}
        >
          {instagram.state == true ? "Sold" : "Available"}
        </span>
        {instagram.fixed ? (
          <>
            <span
              className={`badge  text-uppercase badge-soft-success
          `}
              style={{ fontSize: 14, marginLeft: 5 }}
            >
              Fixed
            </span>
            <span
              className={`badge  text-uppercase badge-soft-success
        `}
              style={{ fontSize: 14, marginLeft: 5 }}
            >
              {instagram.fixed_number}
            </span>
          </>
        ) : null}
      </td>
      <td>
        <div className="d-flex gap-2">
          <div className="edit">
            <button
              className="btn  btn-md btn-success edit-item-btn"
              data-bs-toggle="modal"
              data-bs-target="#showModal"
              onClick={() => handleEdit(instagram)}
            >
              <i className="ri-edit-line align-bottom "></i>
            </button>
          </div>
          <div className="link">
            <a
              href={`https://hkj-haitham-tec.com/instagram/${instagram.url}`}
              className="btn  btn-info btn-md edit-item-btn"
              target="_blank"
            >
              <i className="ri-link align-bottom"></i>
            </a>
          </div>
          <div className="sold">
            <button
              className="btn  btn-warning btn-md edit-item-btn"
              onClick={() => handleSold(instagram.id)}
            >
              <i className="ri-money-dollar-circle-line align-bottom"></i>
            </button>
          </div>
          <div className="copy">
            <div
              className="btn   btn-md edit-item-btn"
              style={{ backgroundColor: "#0b9b42", color: "#fff" }}
            >
              <CopyToClipboard
                text={`https://hkj-haitham-tec.com/instagram/${instagram.url}`}
                //   className="btn  btn-success edit-item-btn"
                onCopy={copied}
              >
                <i className="ri-clipboard-line align-bottom "></i>
              </CopyToClipboard>
            </div>
          </div>
          <div className="remove">
            <button
              className="btn  btn-danger btn-md remove-item-btn"
              onClick={() => handleDelete(instagram.id)}
            >
              <i class="ri-delete-bin-6-line  align-bottom"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
}
